import { render } from "./IllustrationOnlyDisclaimer.vue?vue&type=template&id=73cf5c5c&scoped=true"
import script from "./IllustrationOnlyDisclaimer.vue?vue&type=script&lang=js"
export * from "./IllustrationOnlyDisclaimer.vue?vue&type=script&lang=js"

import "./IllustrationOnlyDisclaimer.vue?vue&type=style&index=0&id=73cf5c5c&scoped=true&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cf5c5c"]])

export default __exports__